<script lang="ts">
  // Distribution over ordered bins (arrival/departure times in 30-minute
  // buckets) — inline SVG, no chart library. Distinct from ColumnChart:
  // bins are contiguous rather than separate categories, so the bars touch,
  // and the modal bin is highlighted because it's the thing the card's title
  // is actually about.
  import { accentClasses, edgeLabels } from './chartAccent';

  const {
    labels,
    values,
    accent = 'teal',
    ariaLabel
  }: {
    labels: string[];
    values: number[];
    accent?: string;
    ariaLabel: string;
  } = $props();

  const c = $derived(accentClasses(accent));
  const max = $derived(Math.max(...values, 1));
  const modal = $derived(values.indexOf(max));
  const W = 100;
  const H = 42;
  const BASE = 38;
  const slot = $derived(values.length > 0 ? W / values.length : W);
  const captions = $derived(edgeLabels(labels));
</script>

{#if values.length > 0}
  <div>
    <svg
      viewBox="0 0 {W} {H}"
      preserveAspectRatio="none"
      class="h-24 w-full"
      role="img"
      aria-label="{ariaLabel}: peak {max} at {labels[modal] ?? ''}"
    >
      <line x1="0" y1={BASE} x2={W} y2={BASE} class="stroke-toyama-cloudy-gray" stroke-width="0.5" />
      {#each values as value, i (i)}
        {@const h = value > 0 ? Math.max(1, (value / max) * (BASE - 2)) : 0}
        <rect
          x={i * slot + slot * 0.06}
          y={BASE - h}
          width={slot * 0.88}
          height={h}
          class={i === modal ? c.fill : `${c.fill} opacity-40`}
          rx="0.4"
        >
          <title>{labels[i] ?? ''}: {value}</title>
        </rect>
      {/each}
    </svg>
    {#if captions.length > 0}
      <div class="mt-1 flex justify-between text-[10.5px] text-dark-gray">
        {#each captions as caption, i (i)}<span>{caption}</span>{/each}
      </div>
    {/if}
  </div>
{/if}
